import { Override } from '@rbilabs/intl-menu';

import { EditorState, IQuickFillActionType, Update } from '../../types';

/**
 * Applies late night price overrides to a payload based on the action type and display settings
 */
export const applyLateNightOverrides = (
  payload: Update,
  state: EditorState,
  action: IQuickFillActionType,
  displayLateNightPrice: boolean
): void => {
  if (displayLateNightPrice) {
    if (action === 'price' && typeof payload.price === 'number') {
      payload.overrides = [
        {
          id: Override.lateNight,
          price: payload.price,
          // For price actions, availability defaults to true when not explicitly set
          // This maintains existing behavior for late night pricing scenarios
          availability: payload.availability !== undefined ? !!payload.availability : true,
        },
      ];
    } else if (action === 'availability') {
      const existingQuickFill = state.quickFill.updates.find(u => u.id === payload.id);
      const existingLateNightPrice =
        existingQuickFill?.overrides?.find(o => o.id === Override.lateNight)?.price || 0;

      const isOverrideOnlyUpdate = payload.overrides && payload.overrides.length > 0;

      if (isOverrideOnlyUpdate) {
        const overrideAvailability = payload.availability;
        delete payload.availability;

        // If availability is null, clear overrides by setting empty array
        if (overrideAvailability === null) {
          payload.overrides = [];
        } else {
          payload.overrides = [
            {
              id: Override.lateNight,
              availability: !!overrideAvailability,
              price: existingLateNightPrice,
            },
          ];
        }
      } else {
        // If availability is null, clear overrides by setting empty array (consistent with EditorGridControls)
        if (payload.availability === null) {
          payload.overrides = [];
        } else {
          payload.overrides = [
            {
              id: Override.lateNight,
              availability: !!payload.availability,
              price: existingLateNightPrice,
            },
          ];
        }
      }
    }
  } else {
    payload.overrides = undefined;
  }
};
